<template>
  <v-dialog :value="value" @input="v => v || close()" max-width="1000px">
    <v-card>
      <v-card-title>
        アノテーションフィルター
        <v-spacer></v-spacer>
<!--        <v-chip @click="selectAll"><v-icon small class="mr-1">mdi-checkbox-multiple-marked</v-icon>全て選択</v-chip>-->
<!--        <v-chip @click="clearFilter"><v-icon small>mdi-close-circle</v-icon>クリアー</v-chip>-->
      </v-card-title>
      <v-card-text>
        <v-row class="mb-5">
          <div class="ml-5">
            <v-checkbox
                v-model="applyForManual"
                label="手動アノテーション"
                hide-details
                dense
            >
            </v-checkbox>
          </div>
          <div class="ml-10">
            <v-checkbox
                v-model="applyForAP"
                label="AI MODEL Aのアノテーション"
                hide-details
                dense
            >
            </v-checkbox>
          </div>
        </v-row>
        <v-row>
          <v-col style="border-right: 1px solid grey">
            <div class="text-left bottom_border">
              <v-checkbox
                  class="mt-0 pt-0"
                  v-model="allPanelType"
                  label="異常種類"
                  @change="checkAllPanelType"
                  dense
                  hide-details
              >
              </v-checkbox>
            </div>
            <v-container fluid style="max-height: 500px; overflow-y: scroll;" class="pt-0">
              <v-row v-for="i in panelErrorTypes.length" :key="i">
                <v-checkbox
                    v-model="filteredPanelErrorTypes"
                    :label="errorTypes[panelErrorTypes[i-1]]"
                    hide-details
                    dense
                    :value="panelErrorTypes[i-1]"
                    @change="allPanelType = panelErrorTypes.length === filteredPanelErrorTypes.length"
                >
                </v-checkbox>
              </v-row>
            </v-container>
          </v-col>
          <v-col style="border-right: 1px solid grey">
            <div class="text-left bottom_border">
              <v-checkbox
                  class="mt-0 pt-0"
                  label="異常原因"
                  hide-details
                  dense
                  v-model="allPanelReason"
                  @change="checkAllPanelReason"
              >
              </v-checkbox>
            </div>
            <v-container fluid style="max-height: 500px; overflow-y: scroll;" class="pt-0">
              <v-row v-for="i in panelErrorReasons.length" :key="i">
                <v-checkbox
                    v-model="filteredPanelErrorReasons"
                    :label="errorReasons[panelErrorReasons[i-1]]"
                    hide-details
                    dense
                    :value="panelErrorReasons[i-1]"
                    @change="allPanelReason = panelErrorReasons.length === filteredPanelErrorReasons.length"
                >
                </v-checkbox>
              </v-row>
            </v-container>
          </v-col>
          <v-col style="border-right: 1px solid grey" v-show="applyForAP">
            <div class="text-left bottom_border">
              <v-checkbox
                  class="mt-0 pt-0"
                  label="AI MODEL Aの異常種類"
                  v-model="allAirprobeType"
                  hide-details
                  dense
                  @change="checkAllAirprobeType"
              >
              </v-checkbox>
            </div>
            <v-container style="max-height: 500px; overflow-y: scroll;" class="pt-0">
              <v-row v-for="i in airprobeErrorTypes.length" :key="i">
                <v-checkbox
                    v-model="filteredAirprobeErrorTypes"
                    :label="airprobeErrorTypes[i-1]"
                    hide-details
                    dense
                    :value="airprobeErrorTypes[i-1]"
                    @change="allAirprobeType = airprobeErrorTypes.length === filteredAirprobeErrorTypes.length"
                >
                </v-checkbox>
              </v-row>
            </v-container>
          </v-col>
          <v-col v-show="applyForAP">
            <div class="text-left bottom_border">
              <v-checkbox
                  class="mt-0 pt-0"
                  v-model="allAirprobeSeverity"
                  label="AI MODEL A重大度"
                  hide-details
                  dense
                  @change="checkAllAirprobeSeverity"
              >
              </v-checkbox>
            </div>
            <v-container fluid style="max-height: 500px; overflow-y: scroll;" class="pt-0">
              <v-row v-for="i in airprobeSeverities.length" :key="i">
                <v-checkbox
                    v-model="filteredAirprobeSeverities"
                    :label="airprobeSeverities[i-1]"
                    hide-details
                    dense
                    :value="airprobeSeverities[i-1]"
                    @change="allAirprobeSeverity = airprobeSeverities.length === filteredAirprobeSeverities.length"
                >
                </v-checkbox>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">
          キャンセル
        </v-btn>
        <v-btn color="primary" @click="filter">
          フィルター
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "AnnotationFilterDialog",
  props: ['value', 'abnormalities', 'folderId'],
  data(){
    return {
      airprobeErrorTypes: [],
      panelErrorTypes: ['undefined', 'cell', 'multicell', 'cluster', 'module', 'string', 'junction', 'pid', 'shadow'],
      panelErrorReasons: ['undefined', 'crack', 'sediment', 'vegetation'],
      airprobeSeverities: [],
      filteredPanelErrorTypes: [],
      filteredPanelErrorReasons: [],
      filteredAirprobeErrorTypes: [],
      filteredAirprobeSeverities: [],
      errorTypes: {
        "cell": "ホットスポット",
        "multicell": "マルチホットスポット",
        "cluster": "クラスタバイパス",
        "module": "モジュール異常",
        "string": "ストリング異常",
        "shadow": "影",
        'junction': 'ジャンクションボックス過熱',
        'pid': 'ＰＩＤ現象の疑い',
        'undefined': '未定義'
      },
      errorReasons: {
        "crack": "割れ",
        "sediment": "堆積物",
        "vegetation": "植生",
        'undefined': '未定義'
      },
      applyForAP: true,
      applyForManual: true,
      allPanelType: true,
      allPanelReason: true,
      allAirprobeType: true,
      allAirprobeSeverity: true,
    }
  },
  methods: {
    close(){
      store.updateOpenDialog(false);
      this.$emit('input');
    },
    filter(){
      this.$emit('filter', this.filteredPanelErrorTypes, this.filteredAirprobeErrorTypes, this.filteredPanelErrorReasons, this.filteredAirprobeSeverities, this.applyForManual, this.applyForAP);
      const filter = {
        "apply_for_ap": this.applyForAP,
        "apply_for_manual": this.applyForManual,
        "panel_error_types": this.filteredPanelErrorTypes,
        "airprobe_severities": this.filteredAirprobeSeverities,
        "panel_error_reasons": this.filteredPanelErrorReasons,
        "airprobe_error_types": this.filteredAirprobeErrorTypes,
      };
      store.updateFilter(filter, this.folderId);
      this.close();
    },
    clearFilter(){
      this.filteredPanelErrorReasons = [];
      this.filteredPanelErrorTypes = [];
      this.filteredAirprobeErrorTypes = [];
      this.filteredAirprobeSeverities = [];
    },
    selectAll(){
      this.filteredPanelErrorReasons = this.panelErrorReasons;
      this.filteredPanelErrorTypes = this.panelErrorTypes;
      this.filteredAirprobeErrorTypes = this.airprobeErrorTypes;
      this.filteredAirprobeSeverities = this.airprobeSeverities;
    },
    checkAllPanelType(){
      if (this.allPanelType){
        this.filteredPanelErrorTypes = this.panelErrorTypes;
      }
      else {
        this.filteredPanelErrorTypes = [];
      }
    },
    checkAllPanelReason(){
      if (this.allPanelReason){
        this.filteredPanelErrorReasons = this.panelErrorReasons;
      }
      else {
        this.filteredPanelErrorReasons = [];
      }
    },
    checkAllAirprobeType(){
      if (this.allAirprobeType){
        this.filteredAirprobeErrorTypes = this.airprobeErrorTypes;
      }
      else {
        this.filteredAirprobeErrorTypes = [];
      }
    },
    checkAllAirprobeSeverity(){
      if (this.allAirprobeSeverity){
        this.filteredAirprobeSeverities = this.airprobeSeverities;
      }
      else {
        this.filteredAirprobeSeverities = [];
      }
    },
  },
  watch: {
    value(value){
      if (value){
        store.updateOpenDialog(true);
        this.airprobeErrorTypes = JSON.parse(JSON.stringify(store.getFilter(this.folderId).airprobe_error_types));
        this.airprobeSeverities = JSON.parse(JSON.stringify(store.getFilter(this.folderId).airprobe_severities));
        this.applyForAP = store.getFilter(this.folderId).apply_for_ap;
        this.applyForManual = store.getFilter(this.folderId).apply_for_manual;

        this.filteredPanelErrorTypes = store.getFilter(this.folderId).panel_error_types;
        this.filteredPanelErrorReasons = store.getFilter(this.folderId).panel_error_reasons;
        this.filteredAirprobeErrorTypes = JSON.parse(JSON.stringify(store.getFilter(this.folderId).airprobe_error_types));
        this.filteredAirprobeSeverities = JSON.parse(JSON.stringify(store.getFilter(this.folderId).airprobe_severities));

        this.abnormalities.airprobe_abnormality.list.forEach((abnormality) => {
          if (this.airprobeErrorTypes.findIndex(errorType => errorType === abnormality.airprobe_type) < 0) {
            if (abnormality.airprobe_type){
              this.airprobeErrorTypes.push(abnormality.airprobe_type);
            }
          }
          if (this.airprobeSeverities.findIndex(severity => severity === abnormality.airprobe_severity) < 0){
            if (abnormality.airprobe_severity){
              this.airprobeSeverities.push(abnormality.airprobe_severity);
            }
          }
        });
        this.airprobeErrorTypes.sort();
        this.airprobeSeverities.sort();
        this.allPanelType = this.panelErrorTypes.length === this.filteredPanelErrorTypes.length;
        this.allPanelReason = this.panelErrorReasons.length === this.filteredPanelErrorReasons.length;
        this.allAirprobeType = this.airprobeErrorTypes.length === this.filteredAirprobeErrorTypes.length;
        this.allAirprobeSeverity = this.airprobeSeverities.length === this.filteredAirprobeSeverities.length;
      }
    }
  }
}
</script>

<style scoped>
.bottom_border{
  border-bottom: 1px solid black;
}
</style>
